export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'action', name: '热血动作', description: '燃爆全场的动作漫画，感受肾上腺素飙升的快感', icon: 'ri-sword-line', count: 4 },
  { slug: 'fantasy', name: '奇幻冒险', description: '穿越异世界，开启不可思议的冒险之旅', icon: 'ri-magic-line', count: 4 },
  { slug: 'romance', name: '浪漫恋爱', description: '甜蜜心动，感受最纯真的爱情故事', icon: 'ri-heart-line', count: 2 },
  { slug: 'thriller', name: '悬疑惊悚', description: '紧张刺激，挑战你的心理极限', icon: 'ri-ghost-line', count: 2 },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(c => c.slug === slug);
};